export function HomeSections({ sections }) {
  return sections.map((section) => section);
}
